import site from '@src/state/site/site'
import siteConfig from '@src/state/site/siteConfig'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import axios from 'axios'
import * as Cookies from 'js-cookie'

import { CHEGG_SESSION_KEY } from '@src/utils/localStorage'

export const cheggSessionApi = axios.create({
  baseURL: siteConfig(site, LOCAL_OR_PLAYGROUND).cheggSessionApiUrl,
})

export const deleteCheggSession = async () => {
  // Removing this for now until we figure out how to hit the session API from the browser / bff
  // await cheggSessionApi.delete('/session', {
  //   headers: {
  //     'Session-Id': sessionId,
  //   },
  // })

  Cookies.remove(CHEGG_SESSION_KEY, {
    domain: siteConfig(site, LOCAL_OR_PLAYGROUND).cookieDomain,
  })
}



// WEBPACK FOOTER //
// ./src/utils/http-clients/cheggSessionApi.ts